import React from 'react';
import { Shield, Search, FileText, Bell, Award, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { services } from '../mock';

const iconMap = {
  'Trademark Search': Search,
  'Trademark Filing': FileText,
  'Office Action Response': Bell,
  'Trademark Monitoring': Shield,
  'Brand Protection': Award,
  'Renewal Services': RefreshCw
};

export const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Comprehensive Trademark Services
          </h2>
          <p className="text-lg text-[#8D6E63] max-w-3xl mx-auto">
            From initial search to final registration and beyond, we provide end-to-end trademark protection services tailored to your business needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.title] || Shield;
            return (
              <Card
                key={service.id}
                className="border-2 border-[#D7CCC8] hover:border-[#8D6E63] transition-all duration-300 hover:shadow-xl group"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-[#EFEBE9] rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#3E2723] transition-colors duration-300">
                    <Icon className="w-7 h-7 text-[#3E2723] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-bold text-[#3E2723]">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-[#8D6E63] leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
